import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	parentSeasonID: '',
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		sorted: undefined,
		filters: {
			query: '',
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH EPISODES ***************
			case types.FETCH_EPISODES_LOADING:
				draft.loading = true;
				draft.error = false;
				break;

			case types.FETCH_EPISODES_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				break;

			case types.FETCH_EPISODES_ERROR:
				draft.error = action.payload;
				break;

			// ******************** DETACH EPISODES ********************
			case types.DETACH_EPISODE_LOADING:
				draft.loading = true;
				draft.error = false;
				break;

			case types.DETACH_EPISODE_SUCCESS:
				draft.loading = false;
				draft.data = []; // empting data will cause table rerender and fetching updated data
				draft.error = false;
				break;

			case types.DETACH_EPISODE_ERROR:
				draft.error = action.payload;
				break;

			// *************** SET PARENT SEASON ID ***************
			case types.SET_PARENT_SEASON_ID:
				draft.parentSeasonID = action.payload;
				break;

			// *************** SAVE SORTING OPTIONS ***************
			case types.SAVE_EPISODES_TABLE_SORTING:
				draft.options.sorted = action.payload;
				break;

			// *************** SET SEARCH QUERY ***************
			case types.SET_EPISODES_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				break;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
